// Die Suchmaske und die Seitenleiste zeigen searchDate und searchPersons an. Die
// Suche selbst laeuft ueber travelDate/duration und adults/children/childrenages.
// Gespeicherte Suchen, die nicht aus der Suchmaske stammen (Banner, Deeplinks,
// KIsha), tragen oft nur die zweite Form - dann standen in der Seitenleiste nur
// die Platzhalter "Reisezeitraum" und "Reisende + Zimmer" (Befund 24.09.2026).
// Hier wird die Anzeige-Form aus der Such-Form ergaenzt, wenn sie fehlt.

import { normalizeRoomAllocation } from "../roomAllocation";

const isoToDe = (s) => {
  const m = /(\d{4})-(\d{2})-(\d{2})/.exec(String(s ?? ""));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : null;
};

const fillSearchDate = (state) => {
  if (state.searchDate?.start && state.searchDate?.end) return;
  const start = isoToDe(state.travelDate?.from);
  const end = isoToDe(state.travelDate?.until ?? state.travelDate?.to);
  if (!start || !end) return;
  const raw = String(state.duration?.value ?? "");
  state.searchDate = {
    start,
    end,
    duration: /^\d+$/.test(raw) ? Number(raw) : raw || null,
    durationRange: state.durationDelta ?? null,
    weekPreset: state.duration?.weekPreset ?? null,
    weekdays: state.duration?.weekdays ?? null,
  };
};

const fillSearchPersons = (state) => {
  if (state.searchPersons?.adults) return;
  const alloc = normalizeRoomAllocation(state.roomallocation);
  if (alloc) {
    const ages = alloc.flatMap((r) => r.childrenAges);
    state.searchPersons = {
      adults: alloc.reduce((n, r) => n + r.adults, 0),
      children: ages.length,
      childrenAges: ages,
      rooms: alloc.length,
      roomAllocation: alloc,
    };
    return;
  }
  const adults = Number(state.adults?.value);
  if (!adults) return;
  const children = Number(state.children?.value) || 0;
  state.searchPersons = {
    adults,
    children,
    childrenAges: (state.childrenages || []).slice(0, children).map((c) => Number(c?.value) || 0),
    rooms: Number(state.multiroomdivider) || 1,
    roomAllocation: null,
  };
};

// Auf den ganzen Such-State anwenden (Immer-Draft oder Objekt).
export const fillSearchDisplay = (state) => {
  fillSearchDate(state);
  fillSearchPersons(state);
};
